import { render, staticRenderFns } from "./SelecionarDatasParaComparacao.vue?vue&type=template&id=53d2e0f6&scoped=true"
import script from "./SelecionarDatasParaComparacao.vue?vue&type=script&lang=js"
export * from "./SelecionarDatasParaComparacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2e0f6",
  null
  
)

export default component.exports